import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.5 2a.5.5 0 01.5.5V7h4.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H9v4.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H7V2.5a.5.5 0 01.5-.5h1z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
